/**
 * Visibilità della voce "Admin" nella nav (toggle di build `VITE_ADMIN_NAV_USERS`: username
 * separati da virgola, impostato dal bundle offline deploy/offline-bundle/build-bundle.sh ad
 * AUTH_BREAKGLASS_USER, cioè `tcadmin`).
 *  - vuoto (default): voce visibile a tutti;
 *  - valorizzato: voce visibile solo a quegli utenti (sub JWT `<user>` o `break-glass:<user>`).
 * La voce è solo NASCOSTA: /admin resta raggiungibile via URL e i permessi restano quelli RBAC
 * applicati dal backend. Letta a ogni chiamata (non a import) così i test possono cambiarla con
 * vi.stubEnv.
 */
import type { JwtClaims } from '../auth/types.js';

export function adminNavUsers(): string[] {
  return (import.meta.env['VITE_ADMIN_NAV_USERS'] ?? '')
    .split(',')
    .map((u) => u.trim())
    .filter(Boolean);
}

export function showsAdminNav(claims: JwtClaims | null): boolean {
  const users = adminNavUsers();
  if (users.length === 0) return true;
  const sub = claims?.sub;
  return users.some((u) => sub === u || sub === `break-glass:${u}`);
}
